// extracted by mini-css-extract-plugin
module.exports = {"columns":"TableOptionsModal-columns-1KgGh"};